var map = {
	"./aww.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/aww.ogg",
	"./dha.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/dha.ogg",
	"./e.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/e.ogg",
	"./gu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/gu.ogg",
	"./ha.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ha.ogg",
	"./hii.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/hii.ogg",
	"./k.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/k.ogg",
	"./ka.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ka.ogg",
	"./kaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/kaa.ogg",
	"./kaw.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/kaw.ogg",
	"./kha.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/kha.ogg",
	"./khu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/khu.ogg",
	"./ku.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ku.ogg",
	"./la.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/la.ogg",
	"./laaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/laaa.ogg",
	"./le.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/le.ogg",
	"./level3/bai.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/bai.ogg",
	"./level3/de.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/de.ogg",
	"./level3/dey.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/dey.ogg",
	"./level3/haa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/haa.ogg",
	"./level3/ja.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/ja.ogg",
	"./level3/juu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/juu.ogg",
	"./level3/khu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/khu.ogg",
	"./level3/laa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/laa.ogg",
	"./level3/laa1.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/laa1.ogg",
	"./level3/le.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/le.ogg",
	"./level3/loo.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/loo.ogg",
	"./level3/na.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/na.ogg",
	"./level3/naa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/naa.ogg",
	"./level3/naaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/naaa.ogg",
	"./level3/nee.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/nee.ogg",
	"./level3/paa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/paa.ogg",
	"./level3/pe.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/pe.ogg",
	"./level3/pho.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/pho.ogg",
	"./level3/raa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/raa.ogg",
	"./level3/ree.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/ree.ogg",
	"./level3/roo.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/roo.ogg",
	"./level3/taa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/taa.ogg",
	"./level3/tayee.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/tayee.ogg",
	"./level3/te.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/te.ogg",
	"./level3/tea.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/tea.ogg",
	"./level3/tha.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/tha.ogg",
	"./level3/tke.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/tke.ogg",
	"./level3/toe.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/toe.ogg",
	"./level3/waa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/waa.ogg",
	"./level3/wu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/level3/wu.ogg",
	"./ley.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ley.ogg",
	"./li.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/li.ogg",
	"./lo.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/lo.ogg",
	"./ma.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ma.ogg",
	"./maaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/maaa.ogg",
	"./may.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/may.ogg",
	"./me.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/me.ogg",
	"./mu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/mu.ogg",
	"./na.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/na.ogg",
	"./paaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/paaa.ogg",
	"./pha.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/pha.ogg",
	"./ra.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ra.ogg",
	"./raaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/raaa.ogg",
	"./raaan.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/raaan.ogg",
	"./re.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/re.ogg",
	"./ri.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ri.ogg",
	"./ru.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ru.ogg",
	"./sa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/sa.ogg",
	"./saaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/saaa.ogg",
	"./su.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/su.ogg",
	"./tapari_ta.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/tapari_ta.ogg",
	"./te.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/te.ogg",
	"./tey.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/tey.ogg",
	"./thae.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/thae.ogg",
	"./ti.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/ti.ogg",
	"./wa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/wa.ogg",
	"./waaa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/waaa.ogg",
	"./wo.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/wo.ogg",
	"./wu.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/letters/wu.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/CrosswordPuzzle/content/audios/letters sync recursive ^\\.\\/.*$";